import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailSynopsisSelectorContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: ${480 * Screen.widthRatio}px;
  & > * {
    margin: 0 ${8 * Screen.widthRatio}px 0 0;
  }
`;
export default DetailSynopsisSelectorContainer;
